import React from "react";
import Header from "../Header";
import Footer from "../Footer";
import Title from "../Title";

function BuyCyclePrivacy() {
  document.title = "BuyCycle プライバシーポリシー | 株式会社PO";

  return (
    <div id="privacyPage">
      <Header />
      <div className="contents_inner">
        <Title>Privacy Policy</Title>

        <div className="layout">
          <div className="postBox">
            <div className="postWrap" style={{ display: "block" }}>
              <article className="privacyArticle">
                <h2>BuyCycle（買い物リスト）プライバシーポリシー</h2>
                <p>制定日：2026年1月22日</p>
                <p>改定日：2026年6月17日</p>
                <p>運営者：株式会社PO</p>

                <h3>1. 取得する情報</h3>
                <p>
                  本アプリは、ユーザーが入力した買い物リスト、メモ、撮影または選択した画像等の情報を、
                  アプリの機能提供のために利用します。
                </p>

                <h3>2. 個人情報の収集について</h3>
                <p>
                  本アプリは、氏名、メールアドレス、電話番号、位置情報、連絡先等の
                  個人情報をユーザー登録情報として収集しません。
                </p>

                <h3>3. メモ・画像データの扱い</h3>
                <p>
                  ユーザーが入力した買い物リスト、メモ、撮影または選択した画像は、
                  アプリ内での表示・保存・管理のために利用されます。
                </p>
                <p>
                  これらのデータは、ユーザーの端末内またはアプリ内の保存領域に保存されます。
                </p>
                <p>
                  本アプリは、ユーザーが入力または保存した買い物リスト、メモ、画像等を、
                  当社のサーバーへ送信または保存しません。
                </p>

                <h3>4. カメラ・写真へのアクセスについて</h3>
                <p>
                  本アプリは、メモとして画像を保存する機能を提供するため、
                  ユーザーの許可を得たうえでカメラまたは写真ライブラリへアクセスする場合があります。
                </p>
                <p>
                  カメラまたは写真ライブラリへのアクセスは、ユーザーが画像を撮影または選択する場合に限り利用されます。
                </p>

                <h3>5. 広告配信について</h3>
                <p>
                  本アプリは、フッター等の一部画面にバナー広告を表示するため、
                  第三者の広告配信サービスを利用する場合があります。
                </p>
                <p>
                  広告配信に伴い、広告配信事業者が端末情報、広告識別子、広告の表示・操作に関する情報等を
                  取得する場合があります。
                </p>
                <p>
                  これらの情報は、広告の配信、広告効果の測定、不正利用の防止、
                  サービス改善等の目的で利用される場合があります。
                </p>
                <p>
                  本アプリでは、ユーザーを他社のアプリやWebサイトをまたいで追跡する目的で、
                  当社が広告識別子を利用することはありません。
                </p>

                <h3>6. 解析ツールについて</h3>
                <p>
                  本アプリは、アプリの品質向上や不具合の把握のため、
                  クラッシュ情報や利用状況に関する情報を取得する場合があります。
                </p>
                <p>
                  取得する場合であっても、個人を直接特定する目的では利用しません。
                </p>

                <h3>7. 第三者提供</h3>
                <p>
                  本アプリは、法令に基づく場合を除き、ユーザーが入力または保存した情報を
                  本人の同意なく第三者に提供することはありません。
                </p>
                <p>
                  ただし、広告配信、クラウド保存、解析等の機能提供に必要な範囲で、
                  外部サービス事業者に情報が送信または保存される場合があります。
                </p>

                <h3>8. データの削除について</h3>
                <p>
                  ユーザーは、本アプリ内の操作により、保存した買い物リスト、メモ、画像等のデータを削除できます。
                </p>
                <p>
                  端末内に保存されたデータは、アプリの削除または端末の設定により削除される場合があります。
                </p>

                <h3>9. お問い合わせ</h3>
                <p>
                  本ポリシーに関するお問い合わせは以下までお願いいたします。
                  <br />
                  株式会社PO
                  <br />
                  <a href="/#contact" className="link">
                    お問い合わせフォームはこちら
                  </a>
                </p>

                <h3>10. 改定</h3>
                <p>
                  本ポリシーは、アプリの機能追加、広告配信サービスの変更、
                  法令の改正等に応じて改定されることがあります。
                  改定後は本ページにて告知します。
                </p>
              </article>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default BuyCyclePrivacy;
